import api from "PFCore/api";
import { Id, MetaWithPagination } from "PFTypes";
import { CustomValueImportRow } from "PFTypes/custom_value_import";

export type CustomValueImportRowsParams = {
  page: number;
  perPage: number;
  filter?: "created" | "duplicated" | "merged" | "blocked" | "failed";
};

export type CustomValueImportRowsMeta = {
  totalRows: number;
  totalCreatedRows: number;
  totalDuplicatedRows: number;
  totalFailedRows: number;
  totalMergedRows: number;
  totalBlockedRows: number;
};

export type CustomValueImportRowsResponse = {
  entries: CustomValueImportRow[];
  meta: MetaWithPagination & CustomValueImportRowsMeta;
};

export const fetchCustomValueImportRows = (
  importId: Id,
  params?: CustomValueImportRowsParams
): Promise<CustomValueImportRowsResponse> =>
  api({ url: `admin/custom_values/imports/${importId}/import_rows`, params });
